var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPurpleArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58334 13.0333L15.2375 7.37917C15.4132 7.20348 15.6368 7.11563 15.9083 7.11563C16.1799 7.11563 16.4035 7.20348 16.5792 7.37917C16.7549 7.55487 16.8427 7.77848 16.8427 8.05001C16.8427 8.32153 16.7549 8.54515 16.5792 8.72084L10.2542 15.0458C10.0625 15.2375 9.83889 15.3333 9.58334 15.3333C9.32778 15.3333 9.10417 15.2375 8.9125 15.0458L6.42084 12.5542C6.24514 12.3785 6.1573 12.1549 6.1573 11.8833C6.1573 11.6118 6.24514 11.3882 6.42084 11.2125C6.59653 11.0368 6.82014 10.949 7.09167 10.949C7.3632 10.949 7.58681 11.0368 7.7625 11.2125L9.58334 13.0333Z",
    fill: "#9747FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleArrow);
export default __webpack_public_path__ + "static/media/purple-arrow.c8431c2d3c9b4228509c50305a09fef5.svg";
export { ForwardRef as ReactComponent };